var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoGitlabinline = function SvgLogoGitlabinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 40,
    fill: "none",
    viewBox: "0 0 128 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8C929D",
    d: "M84.399 11.007h-2.57l.01 18.812h10.414v-2.326H84.41l-.012-16.486ZM102.167 26.519a4.426 4.426 0 0 1-3.184 1.32c-1.958 0-2.748-.95-2.748-2.189 0-1.864 1.321-2.755 4.128-2.755.53 0 1.379.058 1.816.139v3.485h-.012m-2.665-11.404a8.61 8.61 0 0 0-5.472 1.934l.908 1.55c1.05-.601 2.335-1.203 4.186-1.203 2.111 0 3.043 1.065 3.043 2.848v.914c-.413-.08-1.262-.139-1.781-.139-4.504 0-6.792 1.552-6.792 4.793 0 2.906 1.816 4.365 4.563 4.365 1.852 0 3.632-.834 4.246-2.188l.471 1.84h1.816v-9.631c-.012-3.045-1.356-5.083-5.188-5.083M112.984 27.923c-.967 0-1.816-.116-2.453-.405v-8.695c.873-.718 1.958-1.239 3.338-1.239 2.488 0 3.443 1.726 3.443 4.515 0 3.96-1.545 5.824-4.328 5.824m1.085-12.804c-2.299 0-3.538 1.54-3.538 1.54v-2.432l-.011-3.218h-2.512l.012 18.35c1.261.52 2.983.798 4.858.798 4.8 0 7.111-3.01 7.111-8.208-.012-4.11-2.146-6.83-5.92-6.83M56.413 13.047c2.276 0 3.75.74 4.705 1.493l1.108-1.887c-1.497-1.296-3.526-1.99-5.695-1.99-5.472 0-9.304 3.275-9.304 9.886 0 6.923 4.139 9.62 8.867 9.62 2.37 0 4.387-.544 5.708-1.088l-.06-7.398v-2.327h-7.015v2.327h4.48l.06 5.615c-.59.29-1.604.521-2.984.521-3.797 0-6.344-2.35-6.344-7.293-.012-5.036 2.618-7.479 6.474-7.479M74.52 11.002h-2.512l.012 3.16V25.08c0 3.044 1.344 5.082 5.176 5.082.531 0 1.05-.046 1.545-.14v-2.21a7.486 7.486 0 0 1-1.167.08c-2.111 0-3.043-1.064-3.043-2.847V17.52h4.21v-2.06h-4.21l-.011-4.458M65.617 29.817h2.512V15.462h-2.512v14.355M65.617 13.482h2.512v-2.466h-2.512v2.466"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E24329",
    fillRule: "evenodd",
    d: "m19.909 38 7.33-22.146H12.58z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC6D26",
    fillRule: "evenodd",
    d: "m19.91 38-7.331-22.146H2.305L19.91 38",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCA326",
    fillRule: "evenodd",
    d: "m2.302 15.854-2.228 6.73c-.099.299-.099.621 0 .92.1.3.292.56.552.745L19.907 38 2.302 15.854Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#E24329",
    fillRule: "evenodd",
    d: "M2.305 15.854h10.274L8.163 2.514c-.227-.686-1.216-.685-1.443 0l-4.415 13.34",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC6D26",
    fillRule: "evenodd",
    d: "m19.906 38 7.331-22.146h10.274L19.906 38",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCA326",
    fillRule: "evenodd",
    d: "m37.511 15.854 2.228 6.73c.099.299.099.621 0 .92-.1.3-.292.56-.551.745L19.906 38l17.605-22.146",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#E24329",
    fillRule: "evenodd",
    d: "M37.512 15.854H27.238l4.416-13.34c.227-.686 1.216-.685 1.443 0l4.415 13.34",
    clipRule: "evenodd"
  })));
};
export default SvgLogoGitlabinline;